<template>
  <div class="new_address_container">
    <PageTop :title="this.addressId ? '编辑收货地址页' : '添加收货地址页' "/>
    <div class="top_tip">
      <img src="./img/tc_img_tipsr@2x.png" srcset="./img/tc_img_tipsr.png 1x, ./img/tc_img_tipsr@2x.png 2x">
      我们将按照您提供的地址邮寄，请准确填写！
    </div>
    <ul class="form_wrap">
      <li class="form_item">
        <IFormItem
          title="收件人">
          <IInput
            v-model="addressDetail.name"
            placeholder="请填写收货人的姓名"/>
        </IFormItem>
      </li>
      <li class="form_item" style="padding-right: 0.7rem;">
        <IFormItem
          title="手机号">
          <IInput
            v-model="addressDetail.phone"
            type="tel"
            placeholder="请填写收货人手机号"
            :maxLenght="maxPhonelength"/>
        </IFormItem>
        <div class="showSelect right" v-fastclick="showSelect">
          +{{select.value}}
          <span class="igetcool cool-sanjiao"></span>
        </div>
      </li>
      <li class="form_item">
        <IFormItem
          title="所在地区">
          <div class="address_detail_wrap"
              @click="openPopup">
            <template>
              <span v-if="addressDetail.provinceName">{{provinceCityDistruct}}</span>
              <span class="gray_span" v-else>请选择收货地区</span>
              <span class="icon_out_wrap"
              ><IGo/></span>
            </template>
          </div>
        </IFormItem>
      </li>
      <li class="form_item">
        <IFormItem
          title="详细地址">
          <div class="textarea_wrap">
            <ITextArea
              v-model="addressDetail.detail"
              placeholder="具体到道路、小区、楼栋号、单元、门牌号等"/>
          </div>
        </IFormItem>
      </li>
    </ul>
    <div class="btn_wrap">
      <IButton size="large" text="添加并使用" height="5"
              :disabled="validate"
              @i-click="requestHandle"/>
      <div class="delete_btn"
          v-if="addressId"
          @click="confirmDelete()">删除地址
      </div>
    </div>
    <Country-select :select="select" @select="selectTel"></Country-select>
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columns"
        @change="changeHandle"
        @cancel="show = false"
        @confirm="chooseCity"/>
    </van-popup>
    <IModal
      :title="alertTitle || '是否删除该地址'"
      :cancel="cancelBtnShow"
      @cancel="deleteSwitch = false"
      @query="deleteHandle"
      :show.sync="deleteSwitch">
      <div v-if="alertTitle">您选择的地址为港澳台或国际地区，寄送随材会产生物流费用，请您随后与班主任联系！</div>
    </IModal>
  </div>
</template>

<script>
import PageTop from '@/components/comment/pageTop';
import { IFormItem, IInput, ITextArea } from '@/components/IForm';
import { IButton } from '@/components/IButton';
import { IGo } from '@/components/IIcon';
import { IModal } from '@/components/IModal';
import { saveAddress, updateAddress, queryAreaList, getAddressDetail, deleteAddressItem, getUserDefaultAddress } from '@/api/address';
import { updateLogisticsAddress } from '@/api/logistics';
import mixin from '@/mixin/auth';
import { validateMobile, LogTrack, resetParamVal } from '@utils';
import { CountrySelect } from '@/components/IForm';
import { encryptRsa } from '@utils/encryptRsa';

export default {
  name: 'NewAddress',
  mixins: [mixin],
  data() {
    const { address_id: addressId, logisticsOrderId, logisticsTids, orderId, itemid: itemId, groupSn, redirect_url, logisticsType } = this.$route.query;

    return {
      select: {
        show: false,
        value: 86
      },
      maxPhonelength: 11,
      addressDetail: {
        name: '',
        phone: null,
        detail: '',
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        districtId: null,
        districtName: null
      },
      addressId,
      logisticsOrderId,
      logisticsTids,
      orderId,
      itemId,
      groupSn,
      show: false,
      cityData: [],
      deleteSwitch: false,
      otherQuery: {},
      alertTitle: '',
      cancelBtnShow: true,
      redirect_url,             // 保存成功后跳转地址
      isDefaultAddress: true,   // 是否有默认地址
      logisticsType,
    };
  },
  computed: {
    provinceCityDistruct() {
      const { provinceName, cityName, districtName } = this.addressDetail;
      const all = `${provinceName} ${cityName} ${districtName}`;
      const pAndC = `${provinceName} ${cityName}`;
      const len = all.length;
      const show = len <= 18 ? all : `${pAndC.slice(0, -(len - 18))}...${districtName}`;
      return show;
    },
    validate() {
      const detail = this.addressDetail;
      return !(detail.name && detail.phone && detail.provinceId && detail.cityId && detail.districtId && detail.detail);
    },
    columns() {
      const cityData = this.cityData;
      let columns = [];
      columns = [
        {
          values: cityData,
          className: `column1`
        }
      ];
      cityData[0] && columns.push({
        values: cityData[0].children || [],
        className: `column2`
      });
      cityData[0] && cityData[0].children && columns.push({
        values: cityData[0].children[0].children,
        className: `column3`
      });
      return columns || [];
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query;
        if (query) {
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  methods: {
    setTrack(options = {}, type = 'show') {
      let oldOP = {
        page_type: 4,
        page_title: document.title,
        url: location.href
      };
      let newOP = Object.assign({}, oldOP, options);
      LogTrack.track(newOP, type);
    },
    showSelect() {
      this.select.show = true;
    },
    selectTel(select) {
      this.select = select;
      if (select.value === 86) {
        this.maxPhonelength = 11;
      } else {
        this.maxPhonelength = 1000;
      }
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    changeHandle(picker, values, index) {
      if (index === 0) {
        picker.setColumnValues(1, values[0].children);
        picker.setColumnValues(2, values[0].children[0].children);
      }
      if (index === 1) {
        picker.setColumnValues(2, values[1].children);
      }
    },
    chooseCity(val) {
      let name = val[0].name;
      let cityArr = ['香港', '澳门', '台湾'];
      if (cityArr.includes(name)) {
        this.alertTitle = '提示';
        this.deleteSwitch = true;
        this.cancelBtnShow = false;
      }

      const [province, city, district] = val;
      this.addressDetail.provinceId = province.id;
      this.addressDetail.provinceName = province.name;
      this.addressDetail.cityId = city.id;
      this.addressDetail.cityName = city.name;
      this.addressDetail.districtId = district.id;
      this.addressDetail.districtName = district.name;
      this.show = false;
    },
    openPopup() {
      this.show = true;
    },
    async getAreaList(id) {
      const params = {
        parentId: -1
      };
      id && (params.parentId = id);
      const { data } = await queryAreaList(params);
      this.cityData = data;
    },
    async getAddressDetail() {
      const params = {};
      params.uid = this.uId;
      params.id = this.addressId;
      const { data } = await getAddressDetail(params);
      this.initAddressInfo(data);
    },
    initAddressInfo(data) {
      const detail = this.addressDetail;
      detail.name = data.name;
      detail.phone = data.phone;
      detail.detail = data.addressDetails,
      detail.provinceId = data.provinceId;
      detail.provinceName = data.provinceName;
      detail.cityId = data.cityId;
      detail.cityName = data.cityName;
      detail.districtId = data.districtId;
      detail.districtName = data.districtName;
      if (data.areaCode) { this.select.value = parseFloat(data.areaCode) }
    },
    requestHandle() {
      const detail = this.addressDetail;
      //  详细地址过滤emoj表情
      detail.detail = detail.detail.replace(/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig, '');
      // 收件人姓名过滤emoji表情
      detail.name = detail.name.replace(/[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig, '');
      if (detail.name.length > 30) { return this.$toast('收件人名称过长，请在30字以内') }
      if (!validateMobile(detail.phone, this.select.value)) { return this.$toast('手机号不合法请重新输入') }
      const opt = {};
      this.addressId && (opt.id = this.addressId);
      opt.addressDetails = detail.detail;
      opt.phone = encryptRsa(detail.phone);
      opt.name = detail.name.replace(/\s+/g, '');
      opt.cityId = detail.cityId;
      opt.provinceId = detail.provinceId;
      opt.districtId = detail.districtId;
      opt.uid = this.uId;
      opt.areaCode = this.select.value;
      this.addressId ? this.updateRequestHandle(opt) : this.saveRequestHandle(opt);
    },
    async saveRequestHandle(params) {
      const { data } = await saveAddress(params);
      this.setTrack({ page_name: '添加收货地址页', btn_name: '添加并使用' }, 'click');

      // this.successHandle(data)
      this._goNextView(data);
    },
    async updateRequestHandle(params) {
      params.id = this.addressId;
      await updateAddress(params);
      this.setTrack({ page_name: '编辑收货地址页', btn_name: '添加并使用' }, 'click');
      this._goNextView(this.addressId);

      // this.successHandle(this.addressId)
    },

    // successHandle(data) {
    //   this.$router.replace({
    //     path: '/h5Pay/mall_order',
    //     query: {...this.otherQuery, address_id: data}
    //   })
    // },
    async deleteHandle() {
      if (this.alertTitle) {
        this.deleteSwitch = false;
        setTimeout(() => {
          this.alertTitle = '';
          this.cancelBtnShow = true;
        }, 300);
        return;
      }
      const params = {};
      params.uid = this.uId;
      params.addressId = this.addressId;
      if (this.otherQuery['current_id'] === this.otherQuery['address_id']) {
        delete this.otherQuery['address_id'];
      } else {
        this.otherQuery['address_id'] = this.otherQuery['current_id'];
      }
      delete this.otherQuery['current_id'];
      await deleteAddressItem(params);
      this.deleteSwitch = false;
      setTimeout(() => {
        if (this.otherQuery['mall_version'] === 'logTrace') {
          window.history.back();
          return;
        } else {
          this._goNextView();
        }
      }, 500);
    },
    async _goNextView(id) {
      let query = { ...this.otherQuery };
      id && (query.address_id = id);
      // 没有地址时且redirect_url存在，自定义跳转
      if ((!this.isDefaultAddress || !this.otherQuery['mall_version']) && this.redirect_url) {
        let redirect_url = resetParamVal(this.redirect_url, 'address_id', id || '');
        // redirect_type： inner、outer
        if (this.otherQuery['redirect_type'] === 'inner') {
          this.$router.replace({
            path: redirect_url
          });
        } else {
          window.location.replace(redirect_url);
        }
        return;
      }

      if (this.otherQuery['mall_version'] === 'external') {
        window.history.back();
        return;
      }
      // 返回兑换码
      if (this.otherQuery['mall_version'] === 'cdkey') {
        window.history.back();
        return;
      }
      if (this.otherQuery['mall_version'] === 'lianbao') {
        this.$router.replace({
          path: '/h5Pay/mall_lianbao_order',
          query
        });
        return;
      } else if (this.otherQuery['mall_version'] === 'logistics') {
        await updateLogisticsAddress({
          orderId: this.logisticsOrderId,
          addressId: id,
          tids: this.logisticsTids.split(',')
        });
        this.$router.replace({
          path: '/mall/logisticsDetail',
          query: {
            orderId: this.logisticsOrderId,
            itemid: this.itemId,
            groupSn: this.groupSn
          }
        });
        return;
      } else if (this.otherQuery['mall_version'] === 'logTrace') {
        // 实物下单物流查询， logisticsType = 1 实物下单列表  logisticsType = 2  实物下单详情 logisticsType = 3 实物下单详情V2(产品说不能动之前的详情故再起一个数值)
        await updateLogisticsAddress({ orderId: this.logisticsOrderId, addressId: id, tids: this.logisticsTids.split(',') });
        let returnPath = this.logisticsType == 1 ? '/mall/logistics' : (this.logisticsType == 2) ? '/mall/logistics/detail' : '/mall/logistics/detailV2';
        let options = {};
        if (this.logisticsType == 2 || this.logisticsType == 3) {
          options.orderId = this.logisticsOrderId;
          options.skuId = this.$route.query.skuId;
          options.erpTid = this.logisticsTids;
        }
        this.$router.replace({
          path: returnPath,
          query: {
            ...options
          }
        });
        return;
      }
      this.$router.replace({
        path: '/h5Pay/mall_order',
        query: this.otherQuery
      });
    },
    confirmDelete() {
      this.deleteSwitch = true;
      this.setTrack({ page_name: this.addressId ? '编辑收货地址页' : '添加收货地址页', btn_name: '删除地址' }, 'click');
    },
    // 获取默认地址
    getUserDefaultAddress() {
      getUserDefaultAddress().then(res => {
        !res.data && (this.isDefaultAddress = false);
      });
    }
  },
  created() {
    this.addressId && this.getAddressDetail();
    !this.addressId && this.getUserDefaultAddress();
    this.setTrack({ page_name: this.addressId ? '编辑收货地址页' : '添加收货地址页' }, 'page');
    this.getAreaList();
  },
  mounted() {
    sessionStorage.setItem('getCouponMark', true);
  },
  destroyed() {
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  },
  components: {
    IFormItem,
    IInput,
    ITextArea,
    IButton,
    IGo,
    IModal,
    CountrySelect,
    PageTop
  }
};
</script>

<style scoped lang="stylus">
  @import '~@/assets/styles/var.styl';
  $grayCorlor = #C2C2CC
  .new_address_container {
    .top_tip {
      display flex
      align-items center
      width 100%
      height .44rem
      font-size .14rem
      color #FF5F2E
      font-weight 400
      background-color #FFF5F3

      img {
        width .2rem
        height .2rem
        margin-left .2rem
        margin-right .07rem
      }
    }

    .form_wrap {
      background-color $white

      .form_item {
        position relative
        padding 0 20px

        .showSelect {
          font-size 0.16rem
          display flex
          align-items center

          .cool-sanjiao {
            font-size 0.14rem
            color #c6c7cb
          }
        }

        .right {
          position absolute
          right 0
          top 0
          width 0.64rem
          height 100%
          color #41414d
          font-size 0.16rem
        }
      }

      .textarea_wrap {
        padding-top 23px
        padding-bottom 21px
      }

      .address_detail_wrap {
        display flex
        justify-content space-between
        align-items center
        line-height 64px
        color #41414D
        font-weight 500

        .gray_span {
          color $grayCorlor
          font-weight 400
        }
      }
    }

    .btn_wrap {
      text-align center
      margin-top 20px
      padding 0 20px

      .delete_btn {
        line-height 20px
        padding 20px 0
        color #FF5F2E
        font-size 18px
      }
    }
  }
</style>
